export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10692.7cd4557e.jpg";